<template>

</template>

<script>
export default {
  name: "RealTimeNotifications",
  mounted() {
    console.log(this.$props.userId);
    Echo.private(`App.Models.User.${this.$props.userId}`)
      .notification((e) => {
        this.makeToast(e.notify.title, e.notify.body, e.notify.link);
      });
  },
  props: {
    userId: Number,
  },
  methods: {
    makeToast(title, content, link) {
      const h = this.$createElement

      this.$bvToast.toast(h(
        "div",
        {
          domProps: {
            innerHTML: content,
          }
        }
      ), {
        href: link,
        title: title
      })
    }
  }
}
</script>

<style scoped>

</style>
